export const APP_STORE_URL = "https://apps.apple.com/gb/app/meet-leo-maths-for-kids/id6767237908";

export const CONTACT_EMAIL = "founder@meetleo.co.uk";
export const INSTAGRAM_URL = "https://instagram.com/leo.ai";

export const art = (name) => `${process.env.PUBLIC_URL}/art/${name}`;
